import DataStore from "./../stores/DataStore";
import { when } from "mobx";

/**
 * @class
 * Hier soll die Klasse entstehen, welche die Daten für das AttributEdit "hält".
 * GGf. müssen Daten noch vom Server abgefragt werden, wenn diese nicht direkt dem AttributEdit übergeben werden.
 * Das soll ebenfalls durch den DataHandler unter verwendung des RequestsHandlers geschehen.
 */
class DataHandler {
  /**
   * @constructor
   * @param {RequestHandler} requestHandler Für Abfragen an den Server um Daten abzurufen
   * @param {object} dataOptions Optionen für das Datahandlng (genauere Doku folgt..)
   * @param {Array} dataOptions.data Array an Daten
   * @param {string} dataOptions.data.id id des zu einfügenden Datums
   * @param {*} dataOptions.data.value Wert der Daten
   * @param {MessageHandler} messageHandler Für allg. Nachrichtenanzeige und fürs Debugging
   */
  constructor(dataOptions) {
    const { requestKeys = [] } = dataOptions;
    this.requestHandler = DataStore.getHandler().requestHandler;
    this.dataOptions = dataOptions;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.DataStore = DataStore;
    this.refreshData();
    if (this.dataOptions.data) {
      this.insertData(this.transformIn(this.dataOptions.data));
      when(
        () =>
          requestKeys.every(
            (key) =>
              this.DataStore.requestStore.requests[key] !== undefined &&
              this.DataStore.requestStore.requests[key].state !== "loading"
          ),
        () => this.insertData(this.transformIn(this.dataOptions.data))
      );
    }
    DataStore.dataHandler=this; 
  }
 
  transformIn(data) {
    return data;
  }
  transformOut(data) {
    return data;
  }
  /**
   * @function DataHandler.getAllModuls gibt alle (eingeschränkten) Module zurück
   * @param {Boolean?}[false] visible nur sichtabre Module?
   * @param {Boolean}[false] notVirtuell nur nicht virtuelle AttributModule?
   */
  getAllModuls(visible, notVirtuell) {
    let moduls = Object.keys(this.DataStore.attributeValues).map(
      (id) => this.DataStore.attributeValues[id].modul
    );
    if (visible) {
      moduls = moduls.filter(
        (modul) => DataStore.attributeValues[modul.id].visible
      );
    }
    if (notVirtuell) {
      moduls = moduls.filter(
        (modul) => !DataStore.attributeValues[modul.id].virtuell
      );
    }
    return moduls.filter((o) => o !== undefined);
  }

  /**
   * @function DataHandler.hasError Prüft alle gespeicherten (vorher gefilterten) AttributModule auf Fehler (Error-Rules, die nicht erfüllt werden)
   * @param {boolean} visible wenn True, werden nicht sichtbare Module herausgefiltert und nicht geprüft
   * @param {boolean} notVirtuell wenn True, werden virtuelle Module herausgefiltert und nicht geprüft
   */
  hasError(visible, notVirtuell) {
    const moduls = this.getAllModuls(visible, notVirtuell);
    let err = false;
    const errLog = [];
    moduls.forEach((modul) => {
      const { error, errText } = modul.hasError();
      err = err || error;
      if (error) errLog.push({ id: modul.getKey(), name: modul.name, errText }); // /errLog[modul.getKey()] = [modul.name].append(errText);
    });
    return { error: err, errLog };
    // return this.DataStore.hasError(visible, notVirtuell);
  }

  /**
   * @function DataHandler.getAllData gibt alle im Handler gespeicherten Module zurück (gefiltert nach parametern)
   * @param {boolean} visible wenn True, werden nicht sichtbare Module herausgefiltert
   * @param {boolean} notVirtuell wenn True, werden virtuelle Module herausgefiltert
   * @return {object[]} ein Array an Key-Value-Paaren
   */
  getAllData(visible, notVirtuell) {
    const modules = this.getAllModuls(visible, notVirtuell);
    return modules.map((m) => m.getKeyValuePair());
  }

  /**
   * @function DataHandler.getAllDataChecked gibt alle im Handler gespeicherten Module zurück (gefiltert nach parametern)
   * @param {Function} successFun Wird ausgeführt, wenn keine Fehler in den Daten vorhanden sind (Rules)
   * @param {Function} errorFun Wird ausgeführt, wenn Fehler in den Daten vorhanden sind (Rules)
   * @param {boolean} visible wenn True, werden nicht sichtbare Module herausgefiltert
   * @param {boolean} notVirtuell wenn True, werden virtuelle Module herausgefiltert
   */
  getAllDataChecked(successFun, errorFun, visible, notVirtuell) {
    const { error, errLog } = this.hasError(visible, notVirtuell);
    if (error) {
      errorFun(errLog);
    } else {
      successFun(this.getAllData(visible, notVirtuell));
    }
  }

  // /**
  //  * @function DataHandler.loadData Wird ausgeführt, um Daten vom Server abzufragen und daraufhin ins AttributEdit zu schreiben
  //  * @deprecated sollte rausgeschmissen werden!
  //  */
  // loadData() {
  //   this.getData(
  //     (data) => this.insertData(data),
  //     (error) => this.getDataError(error)
  //   );
  // }

  // getData(onSuccess, onError) {}

  /**
   * @function DataHandler.insertData funktion, welche übergebene Daten in das AttributEdit reinschreibt
   * @param {object[]} data Ein Array an key-Value Paaren
   */
  insertData(data) {
    if (Array.isArray(data)) {
      data.forEach((d) => {
        const { id, value } = d;
        this.inserDataAttrID(id, value);
      });
    }
  }
  /**
   * @function DataHandler.insertData funktion, welche übergebene Daten in das AttributeEdit schreibt in ein Attribut schreibt.
   * @param {string} id
   * @param {*} value
   */
  inserDataAttrID(id, value) {
    if (DataStore.attributeValues[id])
      DataStore.attributeValues[id].setValue(value);
  }
  refreshData() {
    Object.keys(DataStore.attributeValues).forEach((key) =>
      DataStore.attributeValues[key].setValue(undefined)
    );
  }

  getDataError(error) {
    console.log("Fehler beim Daten Laden");
    console.log(error);
  }

  getInfosFromServer(config, success, error) {
    this.requestHandler.request(config, success, error);
  }
}
export default DataHandler;
